const orEmptyArray = <P>(
  element: ReadonlyArray<P> | null | undefined,
): ReadonlyArray<P> => (element != null ? element : []);

export default orEmptyArray;
